export default __webpack_public_path__ + "static/media/scheduled.3c5a9a5e.svg";